import { BridgeComponent, Message } from '@hotwired/hotwire-native-bridge';
import { Turbo } from '@hotwired/turbo-rails';

interface PresentDropdownNavigationSheetLink {
  text: string;
  url: string;
  style: string;
}

interface PresentDropdownNavigationSheetResponseData {
  selectedLink?: PresentDropdownNavigationSheetLink;
  links: PresentDropdownNavigationSheetLink[];
}

interface PresentDropdownNavigationSheetMessage extends Message {
  data: PresentDropdownNavigationSheetResponseData;
}

export default class DropdownNavigationSheetController extends BridgeComponent {
  public static component = 'dropdown-navigation-sheet';
  public static values = { links: Array };
  declare private readonly linksValue:
    PresentDropdownNavigationSheetLink[] | undefined;

  public present(e: Event): boolean {
    e.stopImmediatePropagation();

    const element = e.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();

    this.send(
      'present',
      {
        links: this.linksValue,
        sourceRect: {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        }
      },
      ({ data }: PresentDropdownNavigationSheetMessage) => {
        if (data.selectedLink) {
          Turbo.visit(data.selectedLink.url);
        }
      }
    );

    return false;
  }
}
